import { Link, useLocation } from 'react-router-dom';
import { MapPin, Mail, Phone, Instagram, Facebook } from 'lucide-react';
import { useSiteSettings } from '@/hooks/useSiteSettings';

export default function Footer() {
    const loc = useLocation();
    const s = useSiteSettings();
    if (loc.pathname.startsWith('/admin')) return null;

    return (
        <footer className="bg-slate-900 text-slate-300 mt-12" data-testid="site-footer">
            <div className="kanbr-container py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-2.5 mb-4">
                        <div className="w-9 h-9 bg-white text-blue-900 flex items-center justify-center font-display font-bold text-lg">K</div>
                        <div>
                            <div className="font-display text-base font-bold text-white">Kanbr Concepts</div>
                            <div className="text-[9px] uppercase tracking-[0.28em] text-slate-400">Modular Wardrobe & Kitchen</div>
                        </div>
                    </div>
                    <p className="text-sm leading-relaxed text-slate-400 max-w-md mb-4">
                        Modular kitchen manufacturers and custom modular wardrobe design experts. Turnkey modular kitchen execution or Job Work manufacturing — factory finish, honest pricing, delivered across Delhi NCR.
                    </p>
                    <div className="space-y-2 text-sm">
                        <div className="flex gap-2.5"><MapPin className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" /> <span data-testid="footer-address">{s.factory_address}</span></div>
                        <div className="flex gap-2.5"><Phone className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" /> <a href={`tel:+${s.whatsapp_number}`}>+91 97737 04406</a></div>
                        <div className="flex gap-2.5"><Mail className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" /> <a href={`mailto:${s.business_email}`}>{s.business_email}</a></div>
                    </div>
                </div>

                <div>
                    <div className="eyebrow text-slate-400 mb-3">Explore</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/job-work" className="hover:text-white">Kitchen &amp; Wardrobes · Job Work</Link></li>
                        <li><Link to="/standard-package" className="hover:text-white">Standard Package · End-to-End</Link></li>
                        <li><Link to="/pre-crafted-modules" className="hover:text-white">Pre-Crafted Modules</Link></li>
                        <li><Link to="/about" className="hover:text-white">About Us</Link></li>
                        <li><Link to="/policy" className="hover:text-white">Policy &amp; Cancellation</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="eyebrow text-slate-400 mb-3">Categories</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/pre-crafted-modules?category=Kitchen%20-%20Base%20Units" className="hover:text-white">Kitchen · Base Units</Link></li>
                        <li><Link to="/pre-crafted-modules?category=Kitchen%20-%20Wall%20Units" className="hover:text-white">Kitchen · Wall Units</Link></li>
                        <li><Link to="/pre-crafted-modules?category=Kitchen%20-%20Tall%20Units" className="hover:text-white">Kitchen · Tall Units</Link></li>
                        <li><Link to="/pre-crafted-modules?category=Wardrobe" className="hover:text-white">Wardrobes</Link></li>
                        <li><Link to="/pre-crafted-modules?category=Other%20Units" className="hover:text-white">Other Units</Link></li>
                    </ul>
                    <div className="flex gap-2 mt-4">
                        <a href="https://instagram.com" target="_blank" rel="noreferrer" className="w-9 h-9 border border-slate-700 flex items-center justify-center hover:bg-slate-800" data-testid="social-instagram"><Instagram className="w-4 h-4" /></a>
                        <a href="https://facebook.com" target="_blank" rel="noreferrer" className="w-9 h-9 border border-slate-700 flex items-center justify-center hover:bg-slate-800" data-testid="social-facebook"><Facebook className="w-4 h-4" /></a>
                    </div>
                </div>
            </div>

            <div className="border-t border-slate-800">
                <div className="kanbr-container py-4 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-slate-500">
                    <div>© {new Date().getFullYear()} Kanbr Concepts. All rights reserved. Modular kitchen manufacturers · Delhi NCR.</div>
                    <div className="flex gap-5">
                        <Link to="/policy" className="hover:text-white">Privacy &amp; Terms</Link>
                        <Link to="/policy#cancellation" className="hover:text-white">Cancellation</Link>
                        <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
